import { Heading,} from "../../components";
import Footer from "components/Footer";
import Navbar from "components/Navbar";
import React, { useEffect } from 'react';
import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;
//const apiUrl = "https://engine.tailriskglobal.com/api";
export default function PBIReport() {
  useEffect(() => {
    
    const setSSOCookie = async () => {
      try {
        const response = await  axios.get(`${apiUrl}/set_sso_cookie`, { withCredentials: true });
        
        // Set iframe source after successful authentication
        //document.getElementById("container").setAttribute("src", "https://dashboard.tailriskglobal.com/en/embed?workspaceId=4436&reportId=13274&portalId=1200&type=report");
        console.log('response.data:', response.data);
        console.log('response.status:', response.status);
        console.log('response.statusText:', response.statusText);
        console.log('Headers:', response.headers);
        //console.log(response.headers);
        //console.log("Set-Cookie Header:", response.headers['set-cookie']);
      } catch (error) {
        console.error('SSO error', error);
      }
    };

    setSSOCookie();
  }, []);


  return (
    <>
      {/* about us section */}
      <div className="w-full bg-gray-300">
        <div className="relative h-[780px] bg-gray-300">
          <div className="absolute left-0 right-0 top-6 m-auto flex flex-1 flex-col items-center gap-[108px] md:gap-[81px] sm:gap-[54px]">
            <div className="container-xs md:px-5">
              <Navbar />
            </div>
          </div>  
          
          <div className="flex justify-center bg-gray-300 py-24 md:py-5">
            <div className="flex flex-col">
              <div>
                <a href="https://dashboard.tailriskglobal.com/en/embed?workspaceId=4436&reportId=13274&portalId=1200&type=report">Report</a>
              </div>

              <iframe 
                src='https://dashboard.tailriskglobal.com/en/embed?workspaceId=4436&reportId=13274&portalId=1200&type=report' 
                width='1200' height='600' frameborder='0'>
              </iframe>
            </div>
          </div>
        </div>
      </div>
      
      <div>
          <Footer />
      </div>

    </>
  );
}
